import baseService from './baseService'

export const userService = {
  login,
  getDropdownData,
  register,
  init,
  resetPassword
}

function login (loginDto) {
  return baseService.postRequest('users/authenticate', loginDto)
}

function getDropdownData () {
  return baseService.getRequest('public/poc/getRegistrationDropdownData')
}

function register (registrationDto) {
  return baseService.postRequest('public/gfi-poc/auth/register', registrationDto)
}

function init (client) {
  return baseService.postRequest(`public/gfi-poc/init`, { url: client })
}

function resetPassword (request) {
  return baseService.postRequest('public/gfi-poc/auth/reset', request)
}
